import { render } from "./BroadcastView.vue?vue&type=template&id=632e7e4a&ts=true"
import script from "./BroadcastView.vue?vue&type=script&lang=ts"
export * from "./BroadcastView.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__